<template>
  <div id="popup-container">
    <v-toolbar dark color="primary">
      <v-toolbar-title class="heading-title">
        Archive Course Data for User(s)
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab x-small class="close" @click="closePanel">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container class="scroll-y overflow" style="height: calc(100vh - 65px - 10px - 48px) !important;">
      <div style="border:1px solid rgba(0, 0, 0, 0.12);">
        <div class="filterSection">
          <v-text-field
                v-model="search"
                label="Filter Users By Name Or Email"
                type="text"
                @change="applyUserSearch"
                append-icon="fa-search"
                class="filter-user"
              ></v-text-field>
          </div>
        <v-expansion-panels accordion 
          v-model="panel"
          multiple>
          <v-expansion-panel>
            <v-expansion-panel-header expand-icon="mdi-menu-down" color="grey50" class="assigned-user-heading assigned-user-heading2">Completed Course User(s)</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-skeleton-loader v-if="loading && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '','table-thead' : 'heading@4' ,'table-row':'text@4' }" class="slider-table"></v-skeleton-loader>
                <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
                <v-data-table
                      v-model="selected"
                      :headers="headers"
                      :options.sync="getCompletedCourseUsers"
                      :server-items-length="serverItemsLength"
                      v-show="!loading"
                      :items="users"
                      item-key="id"
                      show-select
                      class="mb-5 enrol-user-list-tbl"
                      :footer-props="{
                        'items-per-page-options': [5, 10, 15, 25, 50, 75, 100],
                      }"
                    ></v-data-table>
              </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
     
    </v-container>
    <v-footer absolute height="68">
      <v-flex px-4 py-4 text-right>
        <v-btn v-if="!loading" color="grey300" class="mr-4 cancel-button"  @click="closePanel">Cancel</v-btn>
        <v-btn v-if="loading" color="primary" loading></v-btn>
        <v-btn v-else color="dark-blue" class="ml-2 add-course-button" @click="archiveCourseUserData" :disabled="users.length == 0">Archive</v-btn>
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from "@/event-bus.js";
import courseAPI from "@/api/course.js";

export default {
  name: "CompletedUsers",
  components: {
    
  },
  props: {
    id: {
      type: String,
    },
  },
  data() {
    return {
      headers: [
        { text: "First Name", value: "first_name" },
        { text: "Last Name", value: "last_name" },
        { text: "Email", value: "email" },
      ],
      users: [],
      search: "",
      pagination: {},
      getCompletedCourseUsers: {},
      options: {},
      loading: false,
      searchParams: "",
      selected: [],
      successMessage: "User(s) Course Data Archived Successfully",
      errorMessage:
        "Oops, something went wrong! Please check information is correct.",
      serverItemsLength:0,      
      panel: [0,1],
    };
  },
  computed: {
    itemsPerPage: function() {
      return this.pagination.per_page;
    },
    page: function() {
      return this.pagination.current_page;
    },
    params: function() {
      return this.$gf.getQueryString(this.getCompletedCourseUsers, this.serverItemsLength);
    },
    selectedArray: function() {
      let selectedCourseUsers = [];
      this.selected.map(x => {
        selectedCourseUsers.push(x.id);
      });
      return selectedCourseUsers;
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
  },
  watch: {
    getCompletedCourseUsers: {
      handler() {
        this.completedCourseUsers();
      },
      deep: true
    },
  },
  mounted() {
    
  },
  methods: {
    closePanel() {
      this.$emit("closePanel");
    },
    archiveCourseUserData() {
      this.loading = true;
      courseAPI
        .archiveUserCourses({
          id: this.selectedArray
        })
        .then(() => {
          EventBus.$emit('COURSE_USERS_ARCHIVED');
          this.closePanel();
          this.$snotify.success(this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch(() => {
          this.$snotify.error(this.errorMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    completedCourseUsers() {
      this.loading = true;
      courseAPI.getCompletedCourseUsers(this.params+this.searchParams, this.id).then(response => {
        this.loading = false;
        this.users = response.data.data;
        this.serverItemsLength = response.data.meta.pagination.total;
      });
    },
    applyUserSearch() {
      this.getCompletedCourseUsers.page = 1;
      this.searchParams = '';
      
      this.searchParams = this.search && this.search.length > 0 ? "&user_search=" +
      this.search :'';

      this.completedCourseUsers();
    },
  }
};
</script>
<style scoped>
.course-title-wrapper {
    display: flex;
    justify-content: left !important;
    flex-wrap: wrap;
    align-items: center;
    gap: 0 1em;
}

.isMember-Title::after {
    content: "";
    width: 15px;
    height: 14px;
    margin: 4px 1px 0px 0px;
    background-image: url(/static/safeguarding-stars.png);
    background-size: contain;
    background-repeat: no-repeat;
    display: block;
}

.isMember-Title {
    background-color: #83c902;
    height: 20px;
    width: 20px;
    border-radius: 4px;
    display: flex;
    justify-content: center;
}
</style>